import { isAxiosError } from "axios";
import { isRouteErrorResponse } from "react-router-dom";

const NOT_FOUND = 404;
const REFUSED_AS_MISSING = 400;

/**
 * A route failure that means the thing the link pointed to is gone: no route matches, or the
 * entity behind it answered 404. A 5xx or a network failure says nothing about whether it exists
 * and keeps the generic error page.
 */
export const isLinkGoneError = (error: unknown): boolean =>
  (isRouteErrorResponse(error) && error.status === NOT_FOUND) ||
  (isAxiosError(error) && error.response?.status === NOT_FOUND);

/**
 * `isLinkGoneError` for routes that load one entity by id. Deployed environments surface a missing
 * entity as a 400 problem+json, so those routes treat it as gone too.
 */
export const isEntityMissingError = (error: unknown): boolean =>
  isLinkGoneError(error) || (isAxiosError(error) && error.response?.status === REFUSED_AS_MISSING);
